export function isAdmin(userType) {
  return (userType || '').toLowerCase().includes('admin');
}

export function isSuperAdmin(userType) {
  return (userType || '').toLowerCase() === 'sadmin';
}
